import React from "react";
// components
import Silder from "../components/Home/Silder";
import LastNewsComp from "../components/Home/LastNewsComp";
import AdBanner from "../components/Home/AdBanner";
import Newsletter from "../components/Home/Newsletter";
import Enquiry from "../components/Home/Enquiry";
import ContactForm from "../components/Home/ContactForm";
import ContactForm1 from "../components/Home/ContactForm1";
function Home() {
  return (
    <React.Fragment>
      <div className="container">
        <Silder />
        <Enquiry />
        <ContactForm1 />
        <ContactForm />
       {/*  <LastNewsComp />
        <Newsletter /> */}
        <AdBanner />
        
      </div>
    </React.Fragment>
  );
}

export default Home;
